import { Api } from '@/api/api';
import { AssignCallsRequest } from '@/api/requests/calls/assign-calls-request';
import { CallRequestFilters } from '@/api/requests/calls/call-request-filters';
import { UnassignCallsRequest } from '@/api/requests/calls/unassign-calls-request';
import { CallsResponse } from '@/api/responses/calls/calls-response';
import { MyCallsResponse } from '@/api/responses/calls/my-calls-response';
import { Call } from '@/shared/call';

export class CallApi extends Api {
    public async getCallsAsync(filters: CallRequestFilters | null = null): Promise<CallsResponse> {
        return await this.getAsync<CallsResponse>(`v1/call`, filters);
    }
    public async getMyCallsAsync(): Promise<MyCallsResponse> {
        return await this.getAsync<MyCallsResponse>(`v1/call/my-calls`);
    }
    public async assignCallsAsync(request: AssignCallsRequest): Promise<string> {
        return await this.postAsync<string>(`v1/call/assign`, { ...request });
    }
    public async unassignCallsAsync(request: UnassignCallsRequest): Promise<string> {
        return await this.postAsync<string>(`v1/call/unassign`, { ...request });
    }
    public async beginCallAsync(call: Call): Promise<void> {
        await this.putAsync(`v1/call/${call.id}/begin`, call);
    }
    public constructor() {
        super();
    }
}
